import { Record } from 'immutable';
import { Party } from './party';

const EventRecord = Record({
  eventId: null,
  version: null,
  createdDate: null,
  modifiedDate: null,
  name: null,
  eventAgency: new Party(),
  eventClient: new Party(),
  eventProperty: new Party(),
  brand: null,
  chain: null,
  propertyId: null,
  agencyId: null,
  clientReferenceNumber: null,
  startDate: null,
  endDate: null,
  attritionGuaranteePercentage: null,
  attritionMinRoomNights: null,
  commissionRoomPercentage: 0,
  attritionCutoffDate: null,
  roomRateCutoffDate: null,
  depositAmount: null,
  totalFoodBeverageRevenue: null,
  inactive: null,
  autoGenerated: false,
  autoPayment: null,
  canBeDeleted: false
});

export class OnyxEvent extends EventRecord {
  eventId: number;
  version: number;
  createdDate: Date;
  modifiedDate: Date;
  name: string;
  eventAgency: Party;
  eventClient: Party;
  eventProperty: Party;
  brand: string;
  chain: string;
  propertyId: string;
  agencyId: string;
  clientReferenceNumber: string;
  startDate: string;
  endDate: string;
  attritionGuaranteePercentage: string;
  attritionMinRoomNights: string;
  commissionRoomPercentage: number;
  attritionCutoffDate: string;
  roomRateCutoffDate: string;
  depositAmount: string;
  totalFoodBeverageRevenue: string;
  inactive: string;
  autoGenerated: boolean;
  autoPayment: boolean;
  canBeDeleted: boolean;
  groupCodeNumber: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event.ts